import { useEffect, useState } from "react";
import styles from "./collection-page.module.css";
import { getLastPathComponentFromCurrentURL } from "PosterEditor/utils/url-parsing";
import {
  Breadcrumbs,
  BreadcrumbItem,
} from "collection-pages/bread-crumbs/breadcrumbs";
import { usePaths } from "BEDROCK/paths";
import { useCollectionStore } from "entity-store/collections-store/use-collection-store";
import { TemplateCollection } from "PosterEditor/model/template-collection";
import { useTemplateStore } from "entity-store/template-store/use-template-store";
import { useProjectStore } from "entity-store/project-store/use-project-store";
import { ProjectTemplate } from "PosterEditor/model/project-template";
import { ProjectPreview } from "components/common/project-preview";
import { applyTemplateToProject } from "PosterEditor/model/project-template";
import { PageLoadingIndicator } from "admin/shared-components/page-loading-indicator";

interface CollectionPageProps {}

export const CollectionPage = (props: CollectionPageProps) => {
  const { navigateTo, home, mapEditor, collectionList } = usePaths();
  const { loadTemplatesByIDs } = useTemplateStore();
  const { draftProject } = useProjectStore();

  const [collection, setCollection] = useState<TemplateCollection | undefined>(
    undefined
  );
  const [templates, setTemplates] = useState<ProjectTemplate[]>([]);
  const { loadCollectionByID } = useCollectionStore();

  useEffect(() => {
    const id = getLastPathComponentFromCurrentURL();
    if (id) {
      loadCollectionByID(id).then((collection) => {
        if (!collection) {
          navigateTo(home);
          return;
        }
        setCollection(collection);
      });
    } else {
      navigateTo(home);
    }
  }, []);

  useEffect(() => {
    if (!collection) {
      return;
    }
    loadTemplatesByIDs(collection.templateIDs).then((templates) => {
      setTemplates(templates);
    });
  }, [collection?.templateIDs]);

  if (!collection) {
    return <PageLoadingIndicator />;
  }

  const createProjectWithTemplate = (template: ProjectTemplate) => {
    const project = draftProject(false, template);
    applyTemplateToProject(template, project);

    navigateTo(mapEditor + "/" + project.id);
  };

  const breadcrumbs: BreadcrumbItem[] = [
    {
      iconName: "HOME",
      path: home,
    },
    {
      label: "All styles",
      path: collectionList + "/A",
    },
    {
      label: collection.name,
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.header}>
          <Breadcrumbs items={breadcrumbs} />
        </div>
        <div className={styles.collectionSection}>
          <div className={styles.header}>
            <span className={styles.title}>{collection.name}</span>
          </div>
          <div className={styles.body}>
            {templates.map((template) => (
              <button
                className={styles.template}
                onClick={() => {
                  createProjectWithTemplate(template);
                }}
              >
                <ProjectPreview
                  template={template}
                  size={{ width: 300, height: 300 }}
                  showOutline={true}
                  allowHoverEffect={true}
                />
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
